/**
 * "A Special Opportunity" section of the Ryerson Gives Back page
 * (`src/pages/why-ryerson/ryerson-commitment/ryerson-gives-back/index.tsx`, its only importer).
 * Like `../CollegeScholarshipProgramme/CollegeScholarshipProgramme.tsx`, it renders the
 * Environment, Health & Safety image-and-text layouts from
 * `../../EnvironmentHealthSafety/CommunicationAndSafety/` with the copy in
 * `./SpecialOpportunityContent.tsx`.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import CommunicationAndSafetyDesktop from "../../EnvironmentHealthSafety/CommunicationAndSafety/CommunicationAndSafetyDesktop";
import CommunicationAndSafetyMobile from "../../EnvironmentHealthSafety/CommunicationAndSafety/CommunicationAndSafetyMobile";
import { SpecialOpportunityContent } from "./SpecialOpportunityContent";

import { useApplication } from "@ryerson/frontend.application";

/** Renders the section in the visitor's language, falling back to English. Takes no props. */
const SpecialOpportunity: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	// This section's own copy, passed to both layouts despite the name.
	const uniqueImpactMobile = SpecialOpportunityContent[language] || SpecialOpportunityContent.en;

	return (
		<>
			<Media lessThan="lg">
				<CommunicationAndSafetyMobile content={uniqueImpactMobile} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<CommunicationAndSafetyDesktop content={uniqueImpactMobile} />
			</Media>
		</>
	);
};

export default SpecialOpportunity;
